module.exports = __webpack_public_path__ + "static/img/trophy.b77bd7fb.png";